import React from 'react';
import { Col, Container, Row, Image } from "react-bootstrap";
import "./style.css";

function Page(props) {

    return (
        <section id="h-board-directors">
            <Container>
                <h2 className="title-page">Junta Directiva</h2>
                <Row>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/danilo_reynoso.webp"} />
                        <h3>Danilo Reynoso</h3>
                        <label>Presidente</label>
                    </Col>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/elsa_turull.webp"} />
                        <h3>Elsa Turull</h3>
                        <label>Vicepresidente</label>
                    </Col>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/ico_abreu.webp"} />
                        <h3>Ico Abreu</h3>
                        <label>Secretario</label>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/jalsen_santana.webp"} />
                        <h3>Jalsen Santana</h3>
                        <label>Tesorero</label>
                    </Col>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/desiree_reyes.webp"} />
                        <h3>Desiree Reyes</h3>
                        <label>Vocal</label>
                    </Col>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/omar_patin.webp"} />
                        <h3>Omar Patín</h3>
                        <label>Vocal</label>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/norman_stephan.webp"} />
                        <h3>Norman Stephan</h3>
                        <label>Vocal</label>
                    </Col>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/gigi_jimenez.webp"} />
                        <h3>Gigi Jiménez</h3>
                        <label>Vocal</label>
                    </Col>
                    <Col md={4}>
                        <Image src={"../assets/board_directors/tita_hasbun.webp"} />
                        <h3>Tita Hasbún</h3>
                        <label>Vocal</label>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Page;